import { useState, useEffect } from "react";

export const useCheckResolution = () => {
  const [device, setDevice] = useState("desktop");

  const updateDevice = () => {
    let w = window;
    let d = document;
    let documentElement = d.documentElement;
    let body = d.getElementsByTagName("body")[0];
    let widthScreen = w.innerWidth || documentElement.clientWidth || body.clientWidth;

    let deviceType = "";
    // TABLET
    if (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i)) {
      if (widthScreen > 481 && widthScreen < 769) {
        deviceType = "turnTablet";
      } else if (widthScreen < 481) {
        deviceType = "badResolution";
      } else {
        deviceType = "desktop";
      }
    } else if (widthScreen < 1024) {
      deviceType = "badResolution";
    } else {
      deviceType = "desktop";
    }
    setDevice(deviceType);
    /** WORKAROUND per errore in console Chrome: "The message port closed before a response was received." */
    // Add this line:
    return Promise.resolve("Dummy response to keep the console quiet");
  };
  useEffect(() => {
    // initiate the event handler
    window.addEventListener("resize", updateDevice);
    // this will clean up the event every time the component is re-rendered
    return function cleanup() {
      window.removeEventListener("resize", updateDevice);
    };
  });

  return device;
};
